<template>
  <div class="edit">
    <!-- <h2 class="tab-title">{{ $t("Show final document") }}</h2> -->
    <button class="send-email-btn" @click="download()" :style="$route.query.iframe==1?'  top: 0px;  right: 0px;':''" >
      <md-icon style="color: white">picture_as_pdf</md-icon>
      <span>Download</span>
    </button>

       <div class="pdf-pagination" style="height: 45px;
    position: fixed;
    bottom: 0;
    z-index: 11;
    width: 306px;
    border-radius: 15px 15px 0 0;
    left: 50%;
    transform: translate(-50%,0px);
    background: red;
    padding: 3px 0;
    background:rgb(210 210 210 / 85%);">
        <div
          row
          wrap
          style="
            display: flex;
         
          "
        >
          <md-button
            class="md-icon-button md-raised"
            :disabled="noPrevPage"
            @click="prevPage"
          >
            <md-icon>navigate_before</md-icon>
          </md-button>
          <!-- <md-button class="md-raised">First</md-button> -->

          <div xs8 style="margin-top: 10px; ">
            <b>{{ currentPage }} / {{ pageCount }}</b>
          </div>

          <!-- <md-button class="md-raised">Last</md-button> -->
          <md-button
            class="md-icon-button md-raised"
            :disabled="noNextPage"
            @click="nextPage"
          >
            <md-icon>navigate_next</md-icon>
          </md-button>

          <div style="transform: translate(20px, -6px)">
          <md-button
            class="md-fab md-mini md-primary"
            style="box-shadow: none"
            @click="()=>{
let step = pageZoom%0.25 ==0?0.25:(pageZoom%0.25).toFixed(2);
 return pageZoom-step<0.25?pageZoom=0.25: pageZoom-= step;
            }"
            :disabled="pageZoom<=0.5"
          >
            <md-icon>zoom_out</md-icon>
          </md-button>
          <md-input type="number" step="25" min="50" max="200" style="width: 50px;
    text-align: right;
    margin-top: 17px;
    border: 1px solid #cec3c3;
    border-radius: 3px;" v-model="pageZoomAux" @blur.native="pageZoomValidate"  @input.native="pageZoomInput" @keyup.enter="pageZoomValidate"></md-input>
         
          <md-button
            class="md-fab md-mini md-primary"
            style="box-shadow: none"
            :disabled="pageZoom>=2"
            @click="()=>{
let step = 0.25 - (pageZoom%0.25).toFixed(2);
 return pageZoom+step>2?pageZoom=2: pageZoom+= step;
 
            }"
          >
            <md-icon>zoom_in</md-icon>
          </md-button>
        </div>
        </div>
      </div>
      <div class="pdf-image-flieds-container" :style="'zoom:'+pageZoom"> 
        <div style="position: relative">
          <div>
            <img
              id="pdf-image"
              :src="pages[currentPage - 1]"
              alt=""
              style="position: absolute; left: 50%; transform: translateX(-50%);box-shadow: rgba(0, 0, 0, 0.24) 0px 3px 8px;"
            />
          </div>
        </div>

      </div>

  </div>
</template>

<script>
import Vue from "vue";
import axios from "axios";

export default {
  name: "Show",
  components: {
  },
  mounted() {
    var vm = this;
   if(vm.$route.query.iframe==1){
    // document.getElementById('nav').style="display:none";
    //  document.querySelector('h2.tab-title').style="display:none";
   }

   const loader = vm.$loading.show({
              'loader' : 'dots' ,
              'color': '#e94e1b', 
              //'opacity':'1',
              'backgroundColor': '#fff', 
              'height' : 155, 
              'width' : 155 
            });
    axios({
      method: "get",
      url: "/sign/transaction",
      baseURL: process.env.VUE_APP_BASE_API,
      headers: {
        ref: vm.$route.query.ref,
        Authorization: "Bearer " + Vue.prototype.$userData.tokens.access.token,
      },
      params: {
        transactionId: vm.$route.query.transactionId,
      },
    })
      .then((response) => {
        console.log("SUCCESS trn!!");
        console.log(response);
        vm.transactionData = response.data;
        vm.sign_document = response.data.sign_document;

 

        axios({
          method: "post",
          url: "/sign/getDocument",
          baseURL: process.env.VUE_APP_BASE_API,
          headers: {
            ref: vm.$route.query.ref,
            Authorization:
              "Bearer " + Vue.prototype.$userData.tokens.access.token,
          },
          data: {
            docId: vm.sign_document,
          },
        })
          .then((response) => {
            console.log(" docSUCCESS!!");
            console.log(response);
            vm.currentPageImg = response.data.pages[0];
              vm.pages = response.data.pages;
            vm.pageCount = vm.pages.length;
            loader.hide();
          })
          .catch(function (error) {
            console.log(" doc FAILURE!!");
                        console.log(error);
                         loader.hide();

          });
      })
      .catch(function (error) {
        console.log("FAILURE!!");
        console.log(error);
         loader.hide();
      });

   
  },
  data() {
    return this.initialData();
  },
  computed: {
    noPrevPage() {
      return this.currentPage <= 1;
    },
    noNextPage() {
      return this.currentPage === this.pageCount;
    },
  },
  watch: {
    pageZoom: function (newVal) {
      this.pageZoomAux=Math.round(newVal*100);

     
    },
  },
  methods: {
        pageZoomInput(event){
            if (!event.inputType||event.inputType === "increment" || event.inputType === "decrement") {
  this.pageZoomValidate();
}
    },
    pageZoomValidate() {
      const vm =this;
let validZoom= false;
const newVal=vm.pageZoomAux/100;
if(newVal>2){
      vm.pageZoom=2;
     }else  if(newVal<0.25){
      vm.pageZoom=0.25;
     }else{
      validZoom= true;
      vm.pageZoom=Number(newVal);
     }

     if(!validZoom){
      Vue.$toast.open({
              message: "The zoom value must be between 25% and 200%",
              position: "bottom",
              type: "default",
            });
     }
     
    },
    initialData() {
      return {
        pageZoomAux:100,
        pageZoom:1,
        pages:[],
        currentPageImg: null,
        transactionData: {},
        sign_document: "",
        currentPage: 1,
        pageCount: 0,
        src: null,
        zoom: 100,
        width: 0,
        height: 0,
        top: 0,
        left: 0,
        fields: [],
        emails: [],
        showDialog: false,
        newFieldType: "",
        recipient: "",
      };
    },

    download() {
      const vm = this;

      axios({
        method: "post",
        url: "/sign/download?base64=true",
        baseURL: process.env.VUE_APP_BASE_API,
        headers: {
          ref: vm.$route.query.ref,
          Authorization:
            "Bearer " + Vue.prototype.$userData.tokens.access.token,
        },
        data: {
          docId: vm.sign_document,
        },
      })
        .then((response) => {
          console.log(" downSUCCESS!!");
          console.log(response);
      
function downloadPDF(pdf, filename) {
const linkSource = `data:application/pdf;base64,${pdf}`;
const downloadLink = document.createElement("a");
const fileName = filename;
downloadLink.href = linkSource;
downloadLink.download = fileName;
downloadLink.click();}
downloadPDF(response.data.pdf,response.data.filename);
        })
        .catch(function () {
          console.log(" down FAILURE!!");
        });
    },
   
    prevPage() {
      this.currentPage--;
    },
    nextPage() {
      this.currentPage++;
    },
    resize(newRect) {
      this.width = newRect.width;
      this.height = newRect.height;
      this.top = newRect.top;
      this.left = newRect.left;
    },
    pageLoaded(event) {
      this.currentPage = event;
      window.initDocHeight = document.querySelector("#pdf-viewer").offsetHeight;
      console.log("pageloaded");
      console.log(window.initDocHeight);
    },
   

  },
  beforeDestroy() {
    Object.assign(this.$data, this.initialData());
  },
};
</script>

<style scoped>
.tab-title {
  color: #a5a5a5;
  margin-bottom: 30px;
}
.edit {
  margin: 10px;
}


.send-email-btn a {
  color: white !important;
  font-weight: bold !important;
}

.md-button-content .md-checkbox {
  width: 150px;
}

.md-button-content input {
  width: 130px;
}

label,
.md-checkbox-label {
  text-transform: none !important;
}
.send-email-btn {
  margin: 0;
  padding: 0;
  display: inline-block;
  position: relative;
  overflow: hidden;
  outline: none;
  background: transparent;
  border: 0;
  border-radius: 0;
  transition: 0.4s cubic-bezier(0.4, 0, 0.2, 1);
  font-family: inherit;
  line-height: normal;
  text-decoration: none;
  vertical-align: top;
  white-space: nowrap;
  min-width: 120px;
  height: 36px;
  margin: 6px 8px;
  -webkit-user-select: none;
  user-select: none;
  border-radius: 2px;
  font-size: 14px;
  font-weight: 500;
  top: 80px;
  right: 80px;
  cursor: pointer;
  box-shadow: 0 3px 1px -2px rgb(0 0 0 / 20%), 0 2px 2px 0 rgb(0 0 0 / 14%),
    0 1px 5px 0 rgb(0 0 0 / 12%);
  color: #fff;
  color: var(--md-theme-default-text-primary-on-primary, #fff);
  background-color: #e94e1b;
  position: absolute;
}
.send-email-btn a,
.send-email-btn span {
  color: white !important;
  font-weight: bold !important;
}

button.send-email-btn {
    z-index: 2;
}
</style>